import React, { useState, useEffect } from "react";
import { Tab, Tabs, Container, Row, Col, Card } from "react-bootstrap";

import Header_PartnerJazzcash from "../Components/PartnerJazzcash/Header_PartnerJazzcash";
import JazzcashClaim from "../Components/PartnerJazzcash/JazzcashClaim";


const Claims = () => {
  const [userData, setUserData] = useState(null);

  // Load user data from sessionStorage on component mount
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setUserData(user);
    } else {
      console.log("No user found in sessionStorage");
    }
  }, []);

  if (userData && userData.userRole === "JazzCash") {
    return (
      <div className="container-fluid">
        <Header_PartnerJazzcash />
        <div className="mt-4">
        <Row className="mt-3">
                <Col>
                  <Card className="shadow-lg">
                    <Card.Header>
                      <div className="row">
                      <h5 className="text-center">Claims Details</h5>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <JazzcashClaim />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
        </div>
      </div>
    );
  } else {
    return (
      <div className="text-center mt-5">
        You do not have permission to view this page.
      </div>
    );
  }
};

export default Claims;
